import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from '../../../core/services/theme.service';
import { ThemeToggleComponent } from '../../../shared/components/theme-toggle/theme-toggle.component';

@Component({
  selector: 'app-error-layout',
  standalone: true,
  imports: [RouterOutlet, ThemeToggleComponent],
  styleUrls: ['./error-layout.css'],
  templateUrl: './error-layout.html',
})
export class ErrorLayout {
  // Ensures ThemeService is instantiated so dark mode is applied on <html>
  // even when navigating directly to this route without passing through other layouts.
  private _theme = inject(ThemeService);
}
